import React from "react";
import { NavLink } from "react-router-dom";
import { hasPermission } from "../utils/auth";

const navLinkClass =
  "flex items-center gap-2 px-4 py-2.5 text-sm font-medium rounded-lg transition-colors";
const iconClass = "text-lg";

export default function Layout({ children, user, onAuth }) {
  const canCreateContracts = hasPermission(user, "contracts:create");
  const canReadContractTypes = hasPermission(user, "contract-types:read");
  const canReadProposals = hasPermission(user, "proposals:read");
  const canCreateProposals = hasPermission(user, "proposals:create");
  const loginUrl = "/sso";
  return (
    <div className="min-h-screen flex bg-bgLight">
      {/* Sidebar */}
      <aside className="w-64 bg-navy text-white flex flex-col">
        <div className="px-6 py-5 border-b border-white/10">
          <div className="text-xl font-bold">XpressPaper</div>
          <div className="text-xs text-white/70 mt-1">
            Contract Intelligence
          </div>
          {user && (
            <div className="mt-3 text-xs text-white/80">
              {(user.displayName || `${user.first_name || ""} ${user.last_name || ""}`.trim() || user.email || user.employeeId || "User")} ({user.role})
            </div>
          )}
        </div>

        <nav className="flex-1 px-3 py-4 space-y-1 text-sm">
          <NavLink
            to="/dashboard"
            end
            className={({ isActive }) =>
              `${navLinkClass} ${
                isActive ? "bg-white/10" : "hover:bg-white/5"
              }`
            }
          >
            <span className={iconClass}>🏛</span>
            <span>Dashboard</span>
          </NavLink>

          <NavLink
            to="/contracts"
            className={({ isActive }) =>
              `${navLinkClass} ${
                isActive ? "bg-white/10" : "hover:bg-white/5"
              }`
            }
          >
            <span className={iconClass}>📁</span>
            <span>Contracts</span>
          </NavLink>

          <NavLink
            to="/contracts/new"
            className={({ isActive }) =>
              `${navLinkClass} ${
                isActive ? "bg-white/10" : "hover:bg-white/5"
              }`
            }
            style={{ pointerEvents: !canCreateContracts ? "none" : "auto", opacity: !canCreateContracts ? 0.5 : 1 }}
          >
            <span className={iconClass}>➕</span>
            <span>Upload Contract</span>
          </NavLink>

          <NavLink
            to="/contract-types"
            className={({ isActive }) =>
              `${navLinkClass} ${
                isActive ? "bg-white/10" : "hover:bg-white/5"
              }`
            }
            style={{ pointerEvents: !canReadContractTypes ? "none" : "auto", opacity: !canReadContractTypes ? 0.5 : 1 }}
          >
            <span className={iconClass}>🏷</span>
            <span>Contract Types</span>
          </NavLink>

          <NavLink
            to="/proposals"
            className={({ isActive }) =>
              `${navLinkClass} ${
                isActive ? "bg-white/10" : "hover:bg-white/5"
              }`
            }
            style={{ pointerEvents: !canReadProposals ? "none" : "auto", opacity: !canReadProposals ? 0.5 : 1 }}
          >
            <span className={iconClass}>📝</span>
            <span>Proposal Review</span>
          </NavLink>

          <NavLink
            to="/proposals/new"
            className={({ isActive }) =>
              `${navLinkClass} ${
                isActive ? "bg-white/10" : "hover:bg-white/5"
              }`
            }
            style={{ pointerEvents: !canCreateProposals ? "none" : "auto", opacity: !canCreateProposals ? 0.5 : 1 }}
          >
            <span className={iconClass}>➕</span>
            <span>Upload Proposal</span>
          </NavLink>

          <div className="mt-4 border-t border-white/10 pt-4" />

          {/* <button
            type="button"
            className="flex items-center gap-2 px-4 py-2.5 text-xs text-white/70 hover:text-white hover:bg-white/5 rounded-lg"
          >
            <span className={iconClass}>⚙️</span>
            <span>Settings (coming soon)</span>
          </button> */}
        </nav>

        <div className="px-4 py-4 border-t border-white/10 text-xs text-white/60 space-y-2">
          <div>© {new Date().getFullYear()} XpressPaper</div>
          {user ? (
            <button
              type="button"
              onClick={() => {
                localStorage.removeItem("token");
                localStorage.removeItem("user");
                if (onAuth) onAuth(null);
                window.location.href = loginUrl;
              }}
              className="text-white/80 hover:text-white underline"
            >
              Logout
            </button>
          ) : (
            <div>Launch from Master Dashboard</div>
          )}
        </div>
      </aside>

      {/* Main content */}
      <main className="flex-1 p-6">
        {children}
      </main>
    </div>
  );
}
